import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './index.less';
// import { Menu, message, Modal } from 'antd';
import { Menu, Modal } from 'antd';
import wrapReact from '../../../../util/react';
import { actUI } from '../../../../redux/action/ui';
import { sessionStore } from '../../../../util/storage';
import {
  getCiamRedirectUriForLogout,
  getCiamClientId,
  getCiamDomain,
} from '../../../../util/url';
// import deHtmlNotice from '../../../../static/js/notice.js'
// import useTemp from URL_USE

const { SubMenu } = Menu;
const noticeIcon = require('../../../../static/image/privacy notice-icon.png');
const TickedIcon = require('../../../../static/image/Ticked-select.png');
const notSelectIcon = require('../../../../static/image/Ticked-unselect.png');

export class MenuNotice extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isFirstLogin: false,
      isSelect: false,
      isSelectedConuntry: '',
    };
  }

  componentDidMount() {
    const privacvNotice = 'close';// sessionStore.get('privacvNotice');
    const sesseionFirstLogin = false;// sessionStore.get('isFirstLogin');
    const homeCookieMsg = document.cookie;
    if (homeCookieMsg.indexOf('privacvNoticeFlag=true') !== -1) {
      this.setState({
        isFirstLogin: false,
        isSelect: true,
      });
    } else if (privacvNotice === 'open') {
      const { dispatch } = this.props;
      actUI(dispatch, {
        uiIndex: { uiHeader: { uiMenuNotice: { dialogState: true } } },
      });
      if (!sesseionFirstLogin) {
        this.setState({
          isFirstLogin: true,
          isSelect: false,
        });
      } else {
        this.setState({
          isFirstLogin: false,
          isSelect: true,
        });
      }
    }
  }

  handleCancel = () => {
    const { isFirstLogin } = this.state;
    if (isFirstLogin) {
      const { handleLogout } = this.props;
      handleLogout();
      const lang = sessionStore.get('lang') || 'en';
      // eslint-disable-next-line max-len
      // window.location.href = `${getCiamDomain()}/v2/logout?client_id=${getCiamClientId()}&post_logout_redirect_uri=${getCiamRedirectUriForLogout()}&lang=${lang}`;
      // edit by sam 20240619 for uat env
      window.location.href = `${getCiamDomain()}/oidc/logout?client_id=${getCiamClientId()}&post_logout_redirect_uri=${getCiamRedirectUriForLogout()}&lang=${lang}`;
    }
  }

  handleOk = () => {
    // const { isSelect, isFirstLogin, isSelectedConuntry } = this.state;
    // const lang = sessionStore.get('lang');

    // if (isSelect) {
    const { dispatch } = this.props;
    // sessionStore.set('privacvNotice', 'close');
    actUI(dispatch, {
      uiIndex: { uiHeader: { uiMenuNotice: { dialogState: false } } },
    });
    // if (isFirstLogin) {
    //   document.cookie = 'privacvNoticeFlag=true';
    // }
    // } else if (lang === 'en') {
    //   // alert(isSelectedConuntry);
    //   message.error(!isSelectedConuntry ? 'Please select the corresponding country first'
    // : 'you should accepted the terms and conditions.');
    // } else {
    //   message.error(!isSelectedConuntry ? "Veuillez d'abord sélectionner le pays correspondant"
    // : 'Bitte die Datenschutzerklärung bestätigen.');
    // }
  }

  handleClick = () => {
    const { handleNoticeClick } = this.props;
    this.setState(
      {
        isFirstLogin: false,
        isSelect: true,
        isSelectedConuntry: '', // 始终选择语言
      },
      () => {
        handleNoticeClick();
        sessionStore.set('isSelectedConuntry', '#8');// 始终选择语言
        sessionStore.set('privacvNotice', 'open');
        sessionStore.set('isFirstLogin', true);
      },
    );
  }

  acceptFn = () => {
    const { isFirstLogin } = this.state;
    const { isSelect } = this.state;
    if (isFirstLogin) {
      this.setState({
        isSelect: !isSelect,
      });
    }
  }

  ChooseCountry=(e, data) => {
    // alert(data);
    const { isSelectedConuntry } = this.state;
    this.setState({
      isSelectedConuntry: data === '#8' ? '' : !isSelectedConuntry,
    },
    () => {
      sessionStore.set('isSelectedConuntry', data === '#8' ? '' : data);
    });
  }

  render() {
    const {
      filePath, className, ui, intl,
    } = this.props;
    const { dialogState } = ui;
    const { formatMessage } = intl;
    // const { isFirstLogin } = this.state;
    const { isSelect } = this.state;
    const { isSelectedConuntry } = this.state;
    const lang = sessionStore.get('lang');
    let htmlContent = '';
    let selectLocationText = 'Zurück, um Ihren Standort auszuwählen';
    // if (lang && lang === 'de') {
    //   htmlContent = window?.ruleTemp
    // } else {
    //   htmlContent = window?.ruleUsTemp
    // }
    const country = sessionStore.get('isSelectedConuntry');
    // alert(country);
    switch (country) {
      case '#1':
        htmlContent = window?.rule_aut;
        break;
      case '#2':
        htmlContent = window?.rule_de_new;
        break;
      case '#3':
        htmlContent = window?.ruleTempLuxEn;
        selectLocationText = 'Back to select your location';
        break;
      case '#4':
        htmlContent = window?.ruleTempLuxFr;
        selectLocationText = 'Retour pour selectionner votre pays';
        break;
      case '#5':
        htmlContent = window?.ruleTempLuxGe;
        break;
      case '#8':
        break;
      default:
        htmlContent = window?.ruleTemp;
        break;
    }

    return (
      <Menu
        mode="horizontal"
        theme="light"
        className={`${filePath} ${className}`}
      >
        <SubMenu
          key="0"
          title={(
            <span role="button" onClick={this.handleClick} tabIndex={0}>
              <img src={noticeIcon} alt="" />
              {lang && lang === 'de' && <span>Datenschutzerklärung</span>}
              {!(lang && lang === 'de') && <span>Privacy Notice</span>}
            </span>
          )}
        />

        <Modal
          maskClosable={false}
          title={!isSelectedConuntry ? 'Select your location | Wählen Sie Ihren Standort' : 'Privacy Notice | Datenschutzerklärung'}
          visible={dialogState !== false && isSelectedConuntry !== false}
          closable={false}
          onOk={this.handleOk}
          // onCancel={this.handleCancel}
          okText={formatMessage({ id: 'app.btn.close', defaultMessage: 'Close' })}
          cancelText=" "
          // cancelText={
          //   isFirstLogin
          //     ? 'Decline/Abbrechen'
          //     : ' '
          // }
          className="notice-dialog"
        >
          {!isSelectedConuntry && (
            <p>
              <a href="#1" onClick={(e => this.ChooseCountry(e, '#1'))}>Austria</a>
              <br />
              <a href="#2" onClick={(e => this.ChooseCountry(e, '#2'))}>Germany</a>
              <br />
              {/* <a href="#3" onClick={(e => this.ChooseCountry(e, '#3'))}>Luxembourg (English)</a>
              <br />
              <a href="#4" onClick={(e => this.ChooseCountry(e, '#4'))}>Luxembourg (French)</a>
              <br />
              <a href="#5" onClick={(e => this.ChooseCountry(e, '#5'))}>Luxembourg (German)</a>
              <br /> */}
            </p>
          )}

          {isSelectedConuntry && (
            <p>
              <a className="ac" href="#8" onClick={(e => this.ChooseCountry(e, '#8'))}>
                {selectLocationText}
              </a>
              <br />
            </p>
          )}

          {isSelectedConuntry && (
          <div dangerouslySetInnerHTML={{ __html: htmlContent }} />
          )}
          <p>
            {false && isSelectedConuntry && !isSelect && (
              <span role="button" tabIndex={0} onClick={this.acceptFn}>
                <img src={notSelectIcon} alt="" className="select_icon" />
              </span>
            )}
            {false && isSelectedConuntry && isSelect && (
              <span role="button" tabIndex={0} onClick={this.acceptFn}>
                <img src={TickedIcon} alt="" className="select_icon" />
              </span>
            )}
            {false && isSelectedConuntry && (
              <span>
                {isSelectedConuntry && (formatMessage({
                  id: 'Header.notice.content',
                  defaultMessage:
                  'I have read and accepted the terms and conditions.',
                }))}
              </span>
            )}
          </p>
        </Modal>
      </Menu>
    );
  }
}

MenuNotice.propTypes = {
  filePath: PropTypes.string.isRequired,
  className: PropTypes.string.isRequired,
  dispatch: PropTypes.func.isRequired,
  handleLogout: PropTypes.func.isRequired,
  ui: PropTypes.shape({
    dialogState: PropTypes.bool.isRequired,
  }).isRequired,
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
  }).isRequired,
  handleNoticeClick: PropTypes.func.isRequired,
};

export default wrapReact(MenuNotice, 'component_menuNotice');
